const api = 'http://lalielandryapi'

const config = {
  siteName: 'Lalie Landry',
  apiBaseUrl: api,
  slideImageBaseUrl: api + '/upload/slides/',
  serieImageBaseUrl: api + '/upload/series/',
  novelImageBaseUrl: api + '/upload/novels/',
  eventImageBaseUrl: api + '/upload/events/',
  productImageBaseUrl: api + '/upload/products/',
  contactEmail: 'lalie@lalie-landry.com',
  contactMail: '',
  bddTrueValue: "1",
  bddFalseValue: "0",
  stripePublicKey: "pk_test_51SH1273DrfSe3HS4xWHchiv4cb37SK5R7kHSyaIlcHFuO1iuHZjVczeVPBpokgC5aPxDzybM59NzekJTNyFTzokR00itIbnJQ8",
  recaptchaSiteKey: "6Lcb5JItAAAAAAmIJc3k7n_eJgIlKk5oDWgfRUtC",
}

export default config